import './App.css';
import { Route, Routes } from 'react-router-dom';
import ChatView from './pages/ChatView';
import LandingView from './pages/LandingView';
import Login from './pages/Login';
import Landing from './pages/Landing';

function App() {
  return (
    <div className="App">
     
     
    <Routes>
        <Route path="/" element={<Landing/>} />
        <Route path="/:client/:id" element={<ChatView/>} />

        <Route path="/chat/:creator/login" element={<Login/>} />
        <Route path="/:client" element={<ChatView/>} />
        {/* <Route path='/landing' element={<Landing/>} /> */}
       
      </Routes>
    </div>
  );
}

export default App;
